<div
  class="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-cover bg-center"
  style="background-image: url('/login_background1.jpg')"
>
  <div class="pointer-events-none absolute inset-0 bg-slate-900/72"></div>

  <div class="relative z-10 flex w-full max-w-md flex-col items-center px-4">
    <img class="mb-8 h-10 w-auto" src="/Aksia_Logo_white.png" alt="Aksia" />

    @if (!returnUrlValid()) {
      <p class="max-w-xs text-center text-sm text-white/80">
        This page requires an active sign-in session. Please open the
        application you were using and sign in from there.
      </p>
    } @else if (recoveryCodes(); as codes) {
      <p class="mb-3 text-center text-sm text-white/80">
        Your authenticator is set up. Save these recovery codes somewhere safe:
        each one signs you in once if you lose your phone. They won't be shown
        again.
      </p>
      <ul
        class="mb-5 grid grid-cols-2 gap-x-6 gap-y-1 rounded-lg bg-white/95 px-5 py-3 font-mono text-sm text-slate-900"
      >
        @for (c of codes; track c) {
          <li>{{ c }}</li>
        }
      </ul>
      <button
        type="button"
        class="rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
        (click)="continueToApp()"
      >
        I've saved them, continue
      </button>
    } @else if (setup(); as s) {
      <p class="mb-3 text-center text-sm text-white/80">
        Your organisation requires an authenticator app (Google Authenticator,
        Microsoft Authenticator, ...). Scan the QR code with the app (or type
        the key), then enter the 6-digit code it shows.
      </p>

      <div
        class="mb-4 flex flex-col items-center rounded-lg bg-white/95 px-5 py-3 text-center"
      >
        <app-qr-code
          class="mb-2"
          [value]="s.authenticatorUri"
          alt="QR code for your authenticator app"
        />
        <p class="font-mono text-base tracking-wider text-slate-900 select-all">
          {{ s.sharedKey }}
        </p>
        @if (authenticatorLink(); as link) {
          <a
            class="mt-1 inline-block text-xs text-slate-600 underline"
            [href]="link"
            >Open in authenticator app</a
          >
        }
      </div>

      <form
        class="flex flex-col items-center"
        (submit)="submit($event)"
        novalidate
      >
        <input
          class="mb-2 w-56 rounded-lg border-0 bg-white/95 py-2.5 text-center text-lg tracking-[0.3em] text-slate-900 outline-none placeholder:tracking-normal placeholder:text-slate-400"
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          placeholder="Code from the app"
          maxlength="6"
          [value]="code()"
          (input)="updateCode($any($event.target).value)"
        />

        @if (s.emailCodeSentTo) {
          <p class="mb-2 text-center text-xs text-white/75">
            And the code we emailed to {{ s.emailCodeSentTo }}:
          </p>
          <input
            class="mb-2 w-56 rounded-lg border-0 bg-white/95 py-2.5 text-center text-lg tracking-[0.3em] text-slate-900 outline-none placeholder:tracking-normal placeholder:text-slate-400"
            type="text"
            inputmode="numeric"
            placeholder="Emailed code"
            maxlength="8"
            [value]="emailCode()"
            (input)="updateEmailCode($any($event.target).value)"
          />
        }

        @if (
          attemptedSubmit() && (!code() || (s.emailCodeSentTo && !emailCode()))
        ) {
          <p class="mb-2 text-center text-xs text-rose-300">
            Please enter the code(s).
          </p>
        }

        <label
          class="mb-3 flex cursor-pointer items-center gap-2 text-xs text-white/75"
        >
          <input
            class="h-3.5 w-3.5 cursor-pointer accent-slate-300"
            type="checkbox"
            [checked]="rememberDevice()"
            (change)="rememberDevice.set($any($event.target).checked)"
          />
          <span>Remember this device</span>
        </label>

        <button
          class="rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
          type="submit"
          [disabled]="inFlight()"
        >
          Confirm
        </button>

        <button
          type="button"
          class="mt-3 text-xs text-white/75 transition hover:text-white"
          (click)="goToLogin()"
        >
          Back to sign in
        </button>
      </form>
    } @else {
      <span
        class="block h-6 w-6 animate-spin rounded-full border-2 border-white/30 border-t-white"
      ></span>
    }
  </div>

  <footer
    class="absolute bottom-0 w-full py-4 text-center text-xs text-white/40"
  >
    <a class="transition hover:text-white/70" href="mailto:support@aksia.com">
      Contact support
    </a>
  </footer>
</div>
